import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * DimenstionValueGroupingApi - axios parameter creator
 * @export
 */
const DimenstionValueGroupingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/DimenstionValueGrouping/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/DimenstionValueGrouping/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensionValueGrouping: async (type, options = {}) => {
            const localVarPath = `/v1/DimenstionValueGrouping/GetDimensionValueGrouping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimenstionValueGroupingTypes: async (options = {}) => {
            const localVarPath = `/v1/DimenstionValueGrouping/GetDimenstionValueGroupingTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {DimensionValueGroupingToken} [DimensionValueGroupingToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (DimensionValueGroupingToken, options = {}) => {
            const localVarPath = `/v1/DimenstionValueGrouping/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(DimensionValueGroupingToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/DimenstionValueGrouping/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDimensionGroupValue: async (id, options = {}) => {
            const localVarPath = `/v1/DimenstionValueGrouping/RemoveDimensionGroupValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {DimensionValueGroupingToken} [DimensionValueGroupingToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (DimensionValueGroupingToken, options = {}) => {
            const localVarPath = `/v1/DimenstionValueGrouping/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(DimensionValueGroupingToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {UpdateFootwearAndClothingReq} [UpdateFootwearAndClothingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFootwearAndClothing: async (UpdateFootwearAndClothingReq, options = {}) => {
            const localVarPath = `/v1/DimenstionValueGrouping/UpdateFootwearAndClothing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(UpdateFootwearAndClothingReq, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DimenstionValueGroupingApi - functional programming interface
 * @export
 */
const DimenstionValueGroupingApiFp = function (configuration) {
    const localVarAxiosParamCreator = DimenstionValueGroupingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimenstionValueGroupingApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimenstionValueGroupingApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDimensionValueGrouping(type, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDimensionValueGrouping(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimenstionValueGroupingApi.getDimensionValueGrouping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDimenstionValueGroupingTypes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDimenstionValueGroupingTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimenstionValueGroupingApi.getDimenstionValueGroupingTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {DimensionValueGroupingToken} [DimensionValueGroupingToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(DimensionValueGroupingToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(DimensionValueGroupingToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimenstionValueGroupingApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimenstionValueGroupingApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDimensionGroupValue(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDimensionGroupValue(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimenstionValueGroupingApi.removeDimensionGroupValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {DimensionValueGroupingToken} [DimensionValueGroupingToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(DimensionValueGroupingToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(DimensionValueGroupingToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimenstionValueGroupingApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {UpdateFootwearAndClothingReq} [UpdateFootwearAndClothingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFootwearAndClothing(UpdateFootwearAndClothingReq, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFootwearAndClothing(UpdateFootwearAndClothingReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimenstionValueGroupingApi.updateFootwearAndClothing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DimenstionValueGroupingApi - factory interface
 * @export
 */
const DimenstionValueGroupingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DimenstionValueGroupingApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensionValueGrouping(type, options) {
            return localVarFp.getDimensionValueGrouping(type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimenstionValueGroupingTypes(options) {
            return localVarFp.getDimenstionValueGroupingTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {DimensionValueGroupingToken} [DimensionValueGroupingToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(DimensionValueGroupingToken, options) {
            return localVarFp.insert(DimensionValueGroupingToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDimensionGroupValue(id, options) {
            return localVarFp.removeDimensionGroupValue(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {DimensionValueGroupingToken} [DimensionValueGroupingToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(DimensionValueGroupingToken, options) {
            return localVarFp.update(DimensionValueGroupingToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {UpdateFootwearAndClothingReq} [UpdateFootwearAndClothingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFootwearAndClothing(UpdateFootwearAndClothingReq, options) {
            return localVarFp.updateFootwearAndClothing(UpdateFootwearAndClothingReq, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DimenstionValueGroupingApi - object-oriented interface
 * @export
 * @class DimenstionValueGroupingApi
 * @extends {BaseAPI}
 */
class DimenstionValueGroupingApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DimenstionValueGroupingApi
     */
    getAll(options) {
        return DimenstionValueGroupingApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DimenstionValueGroupingApi
     */
    getById(id, options) {
        return DimenstionValueGroupingApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DimenstionValueGroupingApi
     */
    getDimensionValueGrouping(type, options) {
        return DimenstionValueGroupingApiFp(this.configuration).getDimensionValueGrouping(type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DimenstionValueGroupingApi
     */
    getDimenstionValueGroupingTypes(options) {
        return DimenstionValueGroupingApiFp(this.configuration).getDimenstionValueGroupingTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {DimensionValueGroupingToken} [DimensionValueGroupingToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DimenstionValueGroupingApi
     */
    insert(DimensionValueGroupingToken, options) {
        return DimenstionValueGroupingApiFp(this.configuration).insert(DimensionValueGroupingToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DimenstionValueGroupingApi
     */
    remove(id, options) {
        return DimenstionValueGroupingApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DimenstionValueGroupingApi
     */
    removeDimensionGroupValue(id, options) {
        return DimenstionValueGroupingApiFp(this.configuration).removeDimensionGroupValue(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {DimensionValueGroupingToken} [DimensionValueGroupingToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DimenstionValueGroupingApi
     */
    update(DimensionValueGroupingToken, options) {
        return DimenstionValueGroupingApiFp(this.configuration).update(DimensionValueGroupingToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {UpdateFootwearAndClothingReq} [UpdateFootwearAndClothingReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DimenstionValueGroupingApi
     */
    updateFootwearAndClothing(UpdateFootwearAndClothingReq, options) {
        return DimenstionValueGroupingApiFp(this.configuration).updateFootwearAndClothing(UpdateFootwearAndClothingReq, options).then((request) => request(this.axios, this.basePath));
    }
}

export { DimenstionValueGroupingApi, DimenstionValueGroupingApiAxiosParamCreator, DimenstionValueGroupingApiFactory, DimenstionValueGroupingApiFp };
//# sourceMappingURL=dimenstion-value-grouping-api.js.map
